import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPage, hasError } from '../../../states/page/selectors';
import {
	getAllMandatesChunked,
	handleViewMandateBack,
	handleEditMandate,
	getSelectedMandates,
} from '../../../states/managePayments/actions';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import CancelPaymentModal from '../CancelPayment/CancelPaymentModal';

import { showCancelMandateModal } from '../../../states/cancelPayment/selectors';
import { handleShowCancelModal } from '../../../states/cancelPayment/actions';
import ViewPaymentContainer from '../ViewPaymentContainer/ViewPaymentContainer';
import EditPaymentContainer from '../EditPayment/EditPaymentContainer';
import ManagePaymentLandingPage from '../ManagePaymentLandingPage/ManagePaymentLandingPage';
import { getAllAccounts } from '../../../states/accounts/selectors';
import accountPropTypes from '../../../states/accounts/propTypes';
import { ALL_ACCOUNTS } from './constants';
import { getCustomerCapabilities } from '../../../states/limits/actions';
import { getBankId } from '../../../states/session/selectors';
import { getCustomerId } from '../../../states/user/selectors';
import { updateAccounts } from '../../../states/accounts/actions';

const mapState = (state) => ({
	page: getPage(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	hasError: hasError(state),
	showCancelMandateModal: showCancelMandateModal(state),
	accounts: getAllAccounts(state),
	bankId: getBankId(state),
	customerId: getCustomerId(state),
});

const mapDispatch = (dispatch) => ({
	getAllMandatesChunked: () => dispatch(getAllMandatesChunked()),
	handleEdit: ({ id }) => dispatch(handleEditMandate(id)),
	handleShowCancelModal: (mandate) => dispatch(handleShowCancelModal(mandate)),
	handleViewBack: () => dispatch(handleViewMandateBack()),
	getSelectedMandates: (accountIds) => dispatch(getSelectedMandates(accountIds)),
	updateAccounts: (accounts) => dispatch(updateAccounts(accounts)),
	getCustomerCapabilities: (bankId, customerId) => dispatch(getCustomerCapabilities(bankId, customerId)),
});

class LayoutContainer extends Component {
	constructor(props) {
		super(props);
		this.renderPage = this.renderPage.bind(this);
		this.handleCancelSuccess = this.handleCancelSuccess.bind(this);
		this.handleRetry = this.handleRetry.bind(this);
		this.handleAccountChange = this.handleAccountChange.bind(this);
		this.state = {
			selectedAccount: props.accountPickerSelectedAccount,
		};
	}
	componentDidMount() {
		const { getAllMandatesChunked, getSelectedMandates, bankId, customerId, getCustomerCapabilities, updateAccounts } =
			this.props;
		const { selectedAccount } = this.state;

		getCustomerCapabilities(bankId, customerId);
		if (selectedAccount) {
			const account = {
				...selectedAccount,
				actions_available: selectedAccount.actionsAvailable,
			};
			updateAccounts([account]);
			getSelectedMandates([selectedAccount.id]);
		} else {
			getAllMandatesChunked();
		}
	}

	handleCancelSuccess() {
		const { page, getAllMandatesChunked, handleViewBack } = this.props;
		if (page === 'ViewPayment') {
			handleViewBack();
		}
		getAllMandatesChunked();
	}
	handleRetry() {
		this.props.getAllMandatesChunked();
	}

	handleAccountChange(selectedId) {
		const { accounts, getAllMandatesChunked, getSelectedMandates, bankId, customerId, getCustomerCapabilities } =
			this.props;
		getCustomerCapabilities(bankId, customerId);

		let selectedAccount;
		if (selectedId === ALL_ACCOUNTS) {
			getAllMandatesChunked();
			selectedAccount = undefined;
		} else {
			selectedAccount = accounts.find((a) => a.id === selectedId);
			getSelectedMandates([selectedId]);
		}
		this.setState({
			selectedAccount,
		});
	}
	renderPage() {
		const {
			page,
			hasApiCallInProgress,
			hasError,
			handleShowCancelModal,
			handleViewBack,
			handleEditParent,
			handleEdit,
			handleBackParent,
			chatBox,
			handleEditById,
			renderPicker,
			showPaymentDetail,
			totalNumberOfAccounts,
		} = this.props;
		switch (page) {
			case 'ManagePaymentLandingPage':
				return (
					<ManagePaymentLandingPage
						hasApiCallInProgress={hasApiCallInProgress}
						hasError={hasError}
						handleEdit={handleEdit}
						handleCancelView={handleShowCancelModal}
						handleRetry={this.handleRetry}
						handleBackParent={handleBackParent}
						chatBox={chatBox}
						onDropDownChange={this.handleAccountChange}
						accounts={this.props.accounts}
						renderPicker={renderPicker}
						showPaymentDetail={showPaymentDetail}
						selectedAccount={this.state.selectedAccount}
						totalNumberOfAccounts={totalNumberOfAccounts}
					/>
				);
			case 'ViewPayment':
				return (
					<ViewPaymentContainer
						hasApiCallInProgress={hasApiCallInProgress}
						hasError={hasError}
						handleBack={handleViewBack}
						handleCancelView={handleShowCancelModal}
						handleEdit={handleEdit}
					/>
				);
			case 'EditPayment':
				return <EditPaymentContainer handleEditParent={handleEditParent} handleEditById={handleEditById} />;
			default:
				return null;
		}
	}
	render() {
		const { showCancelMandateModal } = this.props;
		return (
			<div>
				{this.renderPage()}
				{showCancelMandateModal && <CancelPaymentModal handleCancelSuccess={this.handleCancelSuccess} />}
			</div>
		);
	}
}
LayoutContainer.propTypes = {
	handleBackParent: PropTypes.func.isRequired,
	getAllMandatesChunked: PropTypes.func.isRequired,
	getSelectedMandates: PropTypes.func.isRequired,
	page: PropTypes.string.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	hasError: PropTypes.bool.isRequired,
	handleEditParent: PropTypes.func.isRequired,
	handleEdit: PropTypes.func.isRequired,
	handleShowCancelModal: PropTypes.func.isRequired,
	showCancelMandateModal: PropTypes.bool.isRequired,
	handleViewBack: PropTypes.func.isRequired,
	handleEditById: PropTypes.func.isRequired,
	chatBox: PropTypes.element.isRequired,
	renderPicker: PropTypes.func.isRequired,
	showPaymentDetail: PropTypes.bool.isRequired,
	accountPickerSelectedAccount: PropTypes.shape(accountPropTypes),
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	totalNumberOfAccounts: PropTypes.number.isRequired,
	bankId: PropTypes.string.isRequired,
	customerId: PropTypes.string.isRequired,
	getCustomerCapabilities: PropTypes.func.isRequired,
	updateAccounts: PropTypes.func.isRequired,
};
export default connect(mapState, mapDispatch)(LayoutContainer);
